// Vanilla CSS for BasePDF page-navigation toolbar. Prefix: pdf-. Aggregated
// into libraryStyles. (react-pdf's Document/Page render their own canvas.)
export const pdfStyles = `
  .pdf-fit { width: 100%; }
  .pdf-nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .pdf-cell { padding-left: 0.5rem; padding-right: 0.5rem; }
  .pdf-clickable { cursor: pointer; }
  .pdf-page { cursor: pointer; }
  .pdf-page-active { font-size: var(--fs-2xl); }
  .pdf-page-inactive { font-size: var(--fs-md); }

  /* viewer mode (opt-in): the stage scrolls on its own, the toolbar never moves. No blur on the
     stage: it is a scroll container. */
  .pdf-viewer {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: var(--rad-catchup-medium);
    border: 1px solid var(--glass-flat-border);
    overflow: hidden;
    outline: none;
  }
  .pdf-viewer:focus-visible { box-shadow: 0 0 0 3px rgba(84,187,203,0.35); }
  .pdf-stage {
    box-sizing: border-box;
    height: min(64vh, 720px);
    overflow: auto;
    padding: var(--space-4);
    background: linear-gradient(180deg, rgba(230,240,243,0.9) 0%, rgba(214,232,237,0.9) 100%);
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .pdf-stage--page { overflow: hidden; align-items: center; }
  .pdf-stage .react-pdf__Document { display: flex; justify-content: center; }
  .pdf-stage canvas {
    border-radius: 4px;
    box-shadow: 0 0 0 1px rgba(84,187,203,0.25), 0 10px 24px -10px rgba(15,72,89,0.35);
  }
  .pdf-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--space-3);
    padding: var(--space-3) var(--space-4);
    border-top: 1px solid var(--glass-flat-border);
    background: var(--glass-flat-solid);
  }
  .pdf-bar-pages { display: flex; align-items: center; gap: var(--space-3); }
  .pdf-bar-pages .ptg-row { flex: 0 0 auto; }
  @media (max-width: 560px) {
    .pdf-stage { height: 56vh; padding: var(--space-2); }
    .pdf-bar { justify-content: center; }
  }
`;
